import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  dismissPostPurchaseSurvey,
  fetchTask,
  handleInsightsHubDeeplink,
  loadPromoBanners,
  popCurrentPromoBanner,
  setTaskCompletion,
  setTaskItemState,
  triggerPostPurchaseSurvey,
  fetchTaskV4,
} from './home-data.actions';
import { TrackingScreenNamesEnum } from '../tracking/tracking.data';
import { TaskItemStateEnum } from './home-data.data';
import { ReportExpandedViewTypesEnum } from '../report-data/report-data.data';

@Injectable()
export class HomeDataDispatcher {
  constructor(private _store: Store<any>) {}

  loadPromoBanners() {
    this._store.dispatch(loadPromoBanners());
  }

  popCurrentPromoBanner() {
    this._store.dispatch(popCurrentPromoBanner());
  }

  triggerPostPurchaseSurvey(
    title: string,
    header: string,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      triggerPostPurchaseSurvey(title, header, trackingScreenName)
    );
  }

  dismissPostPurchaseSurvey() {
    this._store.dispatch(dismissPostPurchaseSurvey());
  }

  fetchTask() {
    this._store.dispatch(fetchTask());
  }

  // Temporary method for I2G Money
  fetchTaskV4() {
    this._store.dispatch(fetchTaskV4());
  }

  setTaskItemState(id: string, state: TaskItemStateEnum) {
    this._store.dispatch(setTaskItemState(id, state));
  }

  setTaskCompletion() {
    this._store.dispatch(setTaskCompletion());
  }

  handleInsightsHubDeeplink(
    deeplink: string,
    reportType: ReportExpandedViewTypesEnum,
    trackingScreenName: TrackingScreenNamesEnum
  ) {
    this._store.dispatch(
      handleInsightsHubDeeplink(deeplink, reportType, trackingScreenName)
    );
  }
}
